import { render } from "./ModalEliminar.vue?vue&type=template&id=ffc0bd64"
import script from "./ModalEliminar.vue?vue&type=script&lang=js"
export * from "./ModalEliminar.vue?vue&type=script&lang=js"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__